import React, { createContext, useContext, useState } from 'react';

const TenantContext = createContext();

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  return context;
};

export const TenantProvider = ({ children }) => {
  const [selectedTenant, setSelectedTenant] = useState(() => {
    const saved = localStorage.getItem('selectedTenant');
    return saved ? JSON.parse(saved) : null;
  });

  const selectTenant = (tenant) => {
    setSelectedTenant(tenant);
    localStorage.setItem('selectedTenant', JSON.stringify(tenant));
  };

  const clearTenant = () => {
    setSelectedTenant(null);
    localStorage.removeItem('selectedTenant');
  };

  const value = {
    selectedTenant,
    selectTenant,
    clearTenant
  };

  return (
    <TenantContext.Provider value={value}>
      {children}
    </TenantContext.Provider>
  );
};